export const iconFontAwesomeCodingRectangleXmark = (
	<i className="fa-solid fa-rectangle-xmark"></i>
);
